import { logErrorOnCrash } from './utils';

export function restartWebOnError(error: any, source: string = null) {
  logErrorOnCrash(error, source);
  window.location.replace(window.location.origin);
}

export function test() {}
